import React from 'react';
import { Row, Col, FormGroup, Label, Input, Button, Table } from 'reactstrap';

export default function TacticEditor({
    tactic,
    saving,
    editorMode,
    activeTool,
    stepActions,
    onChange,
    onSave,
    onDeleteAction,
    onDeleteStepAction,
    onSelectStep,
}) {
    if (!tactic) {
        return (
            <div style={{ color: '#666', fontSize: '0.875rem' }}>
                Selecciona una táctica o crea una nueva.
            </div>
        );
    }

    const players = tactic.players || [];

    const actionLabel = (action) => {
        const from = players[action.fromPlayerIndex];
        const to   = action.toPlayerIndex != null ? players[action.toPlayerIndex] : null;
        const fl   = from ? from.label : `#${action.fromPlayerIndex}`;
        if (action.type === 'pass' && to)  return `Pase: ${fl} → ${to.label} @ ${action.t.toFixed(1)}s`;
        if (action.type === 'shoot')        return `Tiro: ${fl} → portería @ ${action.t.toFixed(1)}s`;
        return `${action.type} @ ${action.t.toFixed(1)}s`;
    };

    const toolHint = editorMode === 'advanced' ? {
        mover: '↕ Arrastra jugadores en el campo para añadir puntos de movimiento',
        pase:  '↗ Arrastra de un jugador a otro en el campo para añadir un pase',
        tiro:  '⚡ Arrastra desde un jugador en el campo para añadir un tiro',
    }[activeTool] : null;

    return (
        <div>
            <Row form>
                <Col md={5}>
                    <FormGroup style={{ marginBottom: '0.5rem' }}>
                        <Label style={{ fontSize: '0.8rem', marginBottom: '2px' }}>Nombre</Label>
                        <Input
                            bsSize="sm"
                            value={tactic.name || ''}
                            onChange={e => onChange({ name: e.target.value })}
                            placeholder="Nombre de la táctica"
                        />
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup style={{ marginBottom: '0.5rem' }}>
                        <Label style={{ fontSize: '0.8rem', marginBottom: '2px' }}>Tipo</Label>
                        <Input
                            type="select" bsSize="sm"
                            value={tactic.type || 'offense'}
                            onChange={e => onChange({ type: e.target.value })}
                        >
                            <option value="offense">Ataque</option>
                            <option value="defense">Defensa</option>
                        </Input>
                    </FormGroup>
                </Col>
                <Col md={4} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '0.5rem' }}>
                    <Button color="success" size="sm" onClick={onSave} disabled={saving} block>
                        {saving ? 'Guardando…' : tactic.id ? 'Guardar' : 'Crear'}
                    </Button>
                </Col>
            </Row>

            {/* Active tool hint */}
            {toolHint && (
                <div style={{ fontSize: '0.78rem', color: '#555', marginBottom: '0.3rem', fontStyle: 'italic' }}>
                    {toolHint}
                </div>
            )}

            {/* Step-based tactics: actions grouped by step */}
            {stepActions && stepActions.length > 0 && (
                <>
                    <div style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.2rem' }}>Pases y tiros</div>
                    <Table size="sm" style={{ fontSize: '0.78rem', marginBottom: 0 }}>
                        <tbody>
                            {stepActions.map((action, idx) => {
                                const from = players[action.fromPlayerIndex];
                                const to   = action.toPlayerIndex != null ? players[action.toPlayerIndex] : null;
                                const step = tactic.steps && tactic.steps[action.step];
                                const when = step && step.action && step.action.timing === 'end' ? 'al llegar' : 'al inicio';
                                const what = action.type === 'pass'
                                    ? `Pase ${from ? from.label : ''} → ${to ? to.label : ''}`
                                    : `Tiro ${from ? from.label : ''}`;
                                return (
                                    <tr key={idx}>
                                        <td>
                                            <button
                                                className="btn btn-link btn-sm p-0"
                                                style={{ fontSize: '0.78rem' }}
                                                onClick={() => onSelectStep(action.step)}
                                            >
                                                Paso {action.step + 1}
                                            </button>
                                            {' · '}{what} <span style={{ color: '#888' }}>({when})</span>
                                        </td>
                                        <td style={{ width: '36px', textAlign: 'right' }}>
                                            <Button
                                                color="danger" size="sm" outline
                                                onClick={() => onDeleteStepAction(action.step)}
                                                style={{ padding: '0 5px', fontSize: '0.7rem' }}
                                            >
                                                ×
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </>
            )}

            {/* Actions review list (timeline tactics) */}
            {!stepActions && tactic.actions && tactic.actions.length > 0 && (
                <>
                    <div style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.2rem' }}>Acciones</div>
                    <Table size="sm" style={{ fontSize: '0.78rem', marginBottom: 0 }}>
                        <tbody>
                            {tactic.actions.map((action, idx) => (
                                <tr key={idx}>
                                    <td>{actionLabel(action)}</td>
                                    <td style={{ width: '36px', textAlign: 'right' }}>
                                        <Button
                                            color="danger" size="sm" outline
                                            onClick={() => onDeleteAction(idx)}
                                            style={{ padding: '0 5px', fontSize: '0.7rem' }}
                                        >
                                            ×
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
        </div>
    );
}
